import { render, staticRenderFns } from "./wy-filter-item-date.vue?vue&type=template&id=1a821dc2&"
import script from "./wy-filter-item-date.vue?vue&type=script&lang=js&"
export * from "./wy-filter-item-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports